// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b7c06138","821":"60dbc4cf"}[chunkId] + ".chunk.js";
};